// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hive_t1hyt253{margin-top:18px;margin-bottom:24px;}\n", ""]);
// Exports
module.exports = exports;
